<template>
  <div>
    <Nav></Nav>
    <div
      id="banner"
      class="swiper-container"
    >
      <div class="swiper-wrapper">
        <!-- 第一张 -->
        <div class="swiper-slide slide1">
          <div>
            <img
              src="../../assets/图/1.jpg"
              class="ani"
              swiper-animate-effect="fadeInRight"
              swiper-animate-duration="1.1s"
              swiper-animate-delay="0s"
              style="opacity:1;"
            >
          </div>

          <div class="right-text">
            <h1
              class="ani"
              swiper-animate-effect="fadeInUp "
              swiper-animate-duration="2.5s"
              swiper-animate-delay="0.5s"
            >谁是「橘朵女孩」?</h1>
            <p
              class="ani"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration="2.6s"
              swiper-animate-delay="1.1s"
            >「橘朵女孩」这个称谓来源于橘朵的粉丝，</p>
            <p
              class="ani"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration="2.7s"
              swiper-animate-delay="1.2s"
            >是消费者自发加的标签。</p>
            <p
              class="ani"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration="2.8s"
              swiper-animate-delay="1.3s"
            >这都源于橘朵女孩对品牌的信任，</p>
            <p
              class="ani"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration="2.9s"
              swiper-animate-delay="1.4s"
            >也是Z世代最重视的与品牌的情感链接。</p>
            <p
              class="ani"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration="3s"
              swiper-animate-delay="1.5s"
            >「橘朵女孩」并不是一个简单的人设,</p>
            <p
              class="ani"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration="3.1s"
              swiper-animate-delay="1.6s"
            >而是一个多元的群体。</p>
            <p
              class="ani"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration="3.2s"
              swiper-animate-delay="1.7s"
            >她们并不是一群风格统一的女孩，</p>
            <p
              class="ani"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration="3.3s"
              swiper-animate-delay="1.8s"
            >而是分散在不同圈层，拥有不同标签的群体</p>
            <p
              class="ani"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration="3.4s"
              swiper-animate-delay="1.9s"
            >橘朵女孩们很清楚自己想要什么，</p>
            <p
              class="ani"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration="3.5s"
              swiper-animate-delay="2s"
            >也总是努力去学习，去争取，去尝试</p>
          </div>
        </div>

        <!-- 第二张 -->
        <div class="swiper-slide slide2">
          <img
            src="../../assets/图/2.jpg"
            class="ani"
            swiper-animate-effect="fadeInRight"
            swiper-animate-duration="1.1s"
            style="opacity:1;"
            swiper-animate-delay="0.5s"
          >
          <div class="right-text">
            <h1
              class="ani"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration="2.5s"
              swiper-animate-delay="0.5s"
            >橘朵和「橘朵女孩」</h1>
            <p
              class="ani"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration="2.6s"
              swiper-animate-delay="1.1s"
            >橘朵将用无尽的创新色彩，</p>
            <p
              class="ani"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration="2.7s"
              swiper-animate-delay="1.2s"
            >为橘朵女孩提供人生探索、实验、发现的工具。</p>
            <p
              class="ani"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration="2.8s"
              swiper-animate-delay="1.3s"
            >鼓励和支持橘朵女孩，</p>
            <p
              class="ani"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration="2.9s"
              swiper-animate-delay="1.4s"
            >用色彩去尝试，去发现，去出彩，</p>
            <p
              class="ani"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration="3s"
              swiper-animate-delay="1.5s"
            >去绽放成自己想要的样子!</p>
          </div>
        </div>

        <!-- 第三张 -->
        <div class="swiper-slide slide3">
          <img
            src="../../assets/图/3.jpg"
            class="ani"
            swiper-animate-effect="fadeInRight"
            swiper-animate-duration="1.1s"
            swiper-animate-delay="0.5s"
            style="opacity:1;"
          >
          <div class="right-text">
            <h1
              class="ani"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration="2.5s"
              swiper-animate-delay="0.5s"
            >「橘朵女孩」说</h1>
            <p
              class="ani"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration="2.6s"
              swiper-animate-delay="1.1s"
            >“推荐给新手&学生党作为第—套彩妆!”</p>
            <p
              class="ani"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration="2.7s"
              swiper-animate-delay="1.2s"
            >“包装设计把我吃得死死的，可简洁可大方可少女~”</p>
            <p
              class="ani"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration="2.8s"
              swiper-animate-delay="1.3s"
            >“梦幻联动超丰富，各种系列全员可爱好吗!”</p>
            <p
              class="ani"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration="2.9s"
              swiper-animate-delay="1.4s"
            >“真是一入橘朵深似海!粉质很细，上色晕染超轻松”</p>
            <p
              class="ani"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration="3s"
              swiper-animate-delay="1.5s"
            >“各种眼影盘满足了我对所有颜色的幻想!”</p>
            <p
              class="ani"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration="3.1s"
              swiper-animate-delay="1.6s"
            >“轻松破坏今年再也不买‘腮红'的魔咒，啊这浅嫩配色，谁能顶得住”</p>
            <p
              class="ani"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration="3.2s"
              swiper-animate-delay="1.7s"
            >“粉质和配色yyds! 朵朵子家真是物超所值”</p>
            <p
              class="ani"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration="3.3s"
              swiper-animate-delay="1.8s"
            >“油画盘自带浪漫朦胧的氛围感,姐妹们赶紧盘起来鸭!”</p>
            <p
              class="ani"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration="3.4s"
              swiper-animate-delay="1.9s"
            >“七色盘太实用了叭，一盘画整脸，出门旅行必备!”</p>
            <p
              class="ani"
              swiper-animate-effect="fadeInUp"
              swiper-animate-duration="3.5s"
              swiper-animate-delay="2s"
            >“从包装到盒子里的印花，就连粉扑都承包了老夫的少女心!”</p>
          </div>
        </div>
      </div>
      <div
        class="swiper-pagination"
        slot="pagination"
        @click="pagination()"
      ></div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'; // 注意引入的是Swiper
import 'swiper/css/swiper.min.css' // 注意这里的引入
// import 'swiper/swiper-bundle.css';
// import SwiperCore, { Navigation, Pagination, Autoplay, EffectFade, Mousewheel } from 'swiper/core';
SwiperCore.use([Navigation, Pagination, Autoplay, EffectFade, Mousewheel]);
import { swiperAnimateCache, swiperAnimate } from "../../utils/swiper.animate1.0.3.min.js"
import Nav from '../../components/Nav.vue';
import Bot from '../../components/Bot.vue';

export default {
  data() {
    return {
      Banner: null,
      isColor: false,
      pag: [
        { index: 1, defalut: '../../assets/品牌介绍/2.png', active: '../../assets/品牌介绍/1.png' },
        { index: 2, defalut: '../../assets/品牌介绍/2.png', active: '../../assets/品牌介绍/1.png' },
        { index: 3, defalut: '../../assets/品牌介绍/2.png', active: '../../assets/品牌介绍/1.png' },
      ]
    }
  },
  components: {
    Nav,
    Bot
  },
  mounted() {
    this.initSwiper()
    const pagination = document.getElementsByClassName('swiper-pagination')[0]
    const customs = document.getElementsByClassName('swiper-pagination-customs')
    const _this = this
    pagination.addEventListener('click', function (e) {
      var target = e.target || e.srcElement;
      if (target.nodeName.toLowerCase() == "span") {
        for (var i = 0; i < customs.length; i++)
          if (customs[i] === target)
            if (i >= 0) {
              _this.Banner.slideTo(i + 1, 1000, true)
            };
      }
    })
  },
  methods: {
    initSwiper() {
      this.Banner = new Swiper('#banner', {
        pagination: {
          el: '.swiper-pagination',
          type: 'custom',
          clickable: true,
          renderCustom: function (swiper, current, total) {
            var customPaginationHtml = "";
            for (var i = 0; i < total; i++) {
              //判断哪个分页器此刻应该被激活
              if (i == current - 1) {
                customPaginationHtml += '<span class="swiper-pagination-customs swiper-pagination-customs-active"></span>';
              } else {
                customPaginationHtml += '<span class="swiper-pagination-customs"></span>';
              }
            }
            return '<span class="swiperPag">' + customPaginationHtml + '</span>';
          }
        },
        // loopAdditionalSlides: 6,
        speed: 1100,
        loop: true, // 循环模式选项
        loopPreventsSlide: true,
        touchRatio: 0.5,
        mousewheel: true,
        forceToAxis: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
          // autoplayDisableOnInteraction: false,
        },
        preventInteractionOnTransition: true,
        on: {
          init: function () {
            swiperAnimateCache(this);
            swiperAnimate(this);
          },
          slideChangeTransitionStart: function () {
            // swiperAnimate(this);

          },
          slideChangeTransitionEnd: function () {
            // swiperAnimateCache(this);
            // swiperAnimate(this);
          },
          slideChange: function () {
            // swiperAnimateCache(this);
            swiperAnimate(this);
          }
        }
      })
    }
  }

}
</script>

<style lang="scss" scoped>
.swiper-container {
  width: 100%;
  height: 100vh;
  background: url("../../assets/品牌介绍/d.png") no-repeat center center;
  background-size: cover;
  .swiper-slide {
    position: relative;
    display: flex;
    align-items: center;
    .ani {
      transition: all 2s;
    }
    img {
      height: 100vh;
    }
  }

  .right-text {
    flex: 1;
    text-align: center;
    white-space: nowrap;
    h1 {
      font-size: 1.5rem;
      margin-bottom: 3.4375rem;
      color: #f4827e;
      transition: all 1s;
    }
    p {
      line-height: 2.5rem;
      font-size: 1.125rem;
      transition: all 1s;
    }
  }
}
</style>
<style lang="scss">
.swiperPag {
  display: flex;
  align-items: flex-end;
  margin: 0 auto;
  justify-content: flex-end;
  flex-direction: column;
  margin-right: 1.4375rem;
}

.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal > .swiper-pagination-bullets {
  top: 2rem;
}
.swiper-pagination-customs {
  cursor: pointer;

  width: 1.5rem;
  height: 1.5rem;
  display: inline-block;
  background: url("../../assets/品牌介绍/2.png") no-repeat center center;
  margin-bottom: 0.25rem;
}
/*自定义分页器激活时的样式表现*/
.swiper-pagination-customs-active {
  cursor: pointer;
  width: 1.5rem;
  height: 1.5rem;
  display: inline-block;
  // border-radius: 0.07rem;
  background-color: #28a7e1;
  background: url("../../assets/品牌介绍/1.png") no-repeat center center;
}
// .my-bullet {
//   background: url("../../assets/品牌介绍/1.png") no-repeat center center;
// }
</style>